import React from 'react';
import PropTypes from 'prop-types';
import SAlertContentTImpl from 'react-s-alert/dist/SAlertContentTmpl';

import Message from './../messages/Message';
import ReloadPageAlert from './ReloadPageAlert';
import ConnectivityAlert from './ConnectivityAlert';
import AnnotationItemRemovedAlert from './AnnotationItemRemovedAlert';
import EssayRestoreAlert from './EssayRestoreAlert';
import EssayRestoredAlert from './EssayRestoredAlert';
import { essayRestoreAlertTypes } from '../../constants/EssayRestoreConstants';

class AlertTemplate extends React.Component {
    static propTypes = {
        classNames: PropTypes.string,
        id: PropTypes.string,
        styles: PropTypes.object,
        customFields: PropTypes.object,
        handleClose: PropTypes.func,
    };

    render() {
        const { classNames, customFields, handleClose, id, styles } = this.props;
        switch (customFields.type) {
        case 'message':
            return (<Message
                model={customFields}
                extraClasses={classNames}
                id={id}
                handleClose={handleClose}
                showClose
                styles={styles}
            />);
        case 'wrong_token':
            return (<ReloadPageAlert
                model={customFields}
                extraClasses={classNames}
                id={id}
                styles={styles}
            />);
        case 'removed_annotation_item':
            return (<AnnotationItemRemovedAlert
                isHighlight={customFields.isHighlight}
                extraClasses={classNames}
                id={id}
                styles={styles}
            />);
        // No `styles`: an inline position would break the centring.
        case essayRestoreAlertTypes.BLANKED:
            return (<EssayRestoreAlert
                model={customFields}
                extraClasses={classNames}
                handleClose={handleClose}
                id={id}
            />);
        case essayRestoreAlertTypes.RESTORED:
            return (<EssayRestoredAlert
                extraClasses={classNames}
                handleClose={handleClose}
                id={id}
            />);
        case 'connectivity':
            return (<ConnectivityAlert
                model={customFields}
                extraClasses={classNames}
                handleClose={handleClose}
                id={id}
                styles={styles}
            />);
        default:
            return <SAlertContentTImpl {...this.props} />;
        }
    }
}

export default AlertTemplate;
